/* Ravenhall Press — interacciones y animaciones */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Cabecera al hacer scroll */
  var header = document.querySelector('.rh-header');
  if (header) {
    // En ordenador, Horizon hace scroll dentro de .page-wrapper (no en la ventana): se escuchan los dos.
    var pw = document.querySelector('.page-wrapper');
    var onScroll = function () { header.classList.toggle('is-scrolled', (window.scrollY || (pw && pw.scrollTop) || 0) > 10); };
    onScroll(); document.addEventListener('scroll', onScroll, { passive: true, capture: true });
  }

  /* Menú móvil (panel lateral fuera de la cabecera para que nada lo tape) */
  var burger = document.querySelector('[data-rh-burger]');
  var drawer = document.querySelector('[data-rh-drawer]');
  var scrim = document.querySelector('[data-rh-scrim]') || document.querySelector('.rh-scrim');
  function setNav(open) {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', String(!open));
    scrim && scrim.classList.toggle('is-open', open);
    burger && burger.setAttribute('aria-expanded', String(open));
    document.documentElement.style.overflow = open ? 'hidden' : '';
  }
  if (burger && drawer) {
    burger.addEventListener('click', function () { setNav(!drawer.classList.contains('is-open')); });
    scrim && scrim.addEventListener('click', function () { setNav(false); });
    var closeBtn = drawer.querySelector('[data-rh-close]');
    closeBtn && closeBtn.addEventListener('click', function () { setNav(false); });
    drawer.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { setNav(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setNav(false); });
    window.addEventListener('pageshow', function () { setNav(false); });
  }

  /* Revelado al entrar en pantalla */
  var els = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  } else { els.forEach(function (el) { el.classList.add('is-in'); }); }

  /* Contadores */
  var counters = document.querySelectorAll('[data-count]');
  if ('IntersectionObserver' in window) {
    var co = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target, end = parseFloat(el.getAttribute('data-count')), t0 = null, dur = 1600;
        co.unobserve(el);
        if (reduce) { el.textContent = end; return; }
        function step(t) { if (!t0) t0 = t; var p = Math.min((t - t0) / dur, 1); el.textContent = Math.round(end * (1 - Math.pow(1 - p, 3))); if (p < 1) requestAnimationFrame(step); }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.4 });
    counters.forEach(function (c) { co.observe(c); });
  }

  /* Inclinación 3D de los libros y brillo de las tarjetas */
  if (!reduce && window.matchMedia('(hover: hover)').matches) {
    document.querySelectorAll('[data-tilt]').forEach(function (wrap) {
      var inner = wrap.querySelector('.rh-book__in'); if (!inner) return;
      wrap.addEventListener('mousemove', function (ev) {
        var r = wrap.getBoundingClientRect(), x = (ev.clientX - r.left) / r.width - .5, y = (ev.clientY - r.top) / r.height - .5;
        inner.style.transform = 'rotateY(' + (-16 + x * 22) + 'deg) rotateX(' + (y * -12) + 'deg) translateY(-6px)';
      });
      wrap.addEventListener('mouseleave', function () { inner.style.transform = ''; });
    });
    document.querySelectorAll('.rh-card').forEach(function (card) {
      card.addEventListener('mousemove', function (ev) {
        var r = card.getBoundingClientRect();
        card.style.setProperty('--mx', (ev.clientX - r.left) + 'px'); card.style.setProperty('--my', (ev.clientY - r.top) + 'px');
      });
    });
  }

  /* Consentimiento de contenido digital en la ficha de producto */
  document.querySelectorAll('[data-rh-consent]').forEach(function (box) {
    var scope = box.closest('[data-rh-buybox]'); if (!scope) return;
    var btns = scope.querySelectorAll('[data-rh-needs-consent]');
    function sync() { btns.forEach(function (b) { b.classList.toggle('is-disabled', !box.checked); b.setAttribute('aria-disabled', String(!box.checked)); if (b.tagName === 'BUTTON') b.disabled = !box.checked; }); }
    box.addEventListener('change', sync); sync();
  });

  /* Oferta: elegir 2 o 3 títulos. Con 2 se eligen cuáles; solo esos se añaden al carrito */
  document.querySelectorAll('form[data-rh-bundle]').forEach(function (f) {
    var scope = f.closest('[data-rh-buybox]') || f, offer = f.closest('.rh-offer'),
      tiers = [].slice.call(scope.querySelectorAll('[data-rh-tier]')),
      pick = f.querySelector('[data-rh-pick]'), pickN = f.querySelector('[data-rh-pick-n]'),
      checks = [].slice.call(f.querySelectorAll('[data-rh-pick-item]')),
      btn = f.querySelector('[data-rh-bundle-btn]'), consent = f.querySelector('[data-rh-consent]'),
      fan = offer ? offer.querySelectorAll('.rh-pack__books .rh-book') : [],
      count = checks.length, k = Number(f.getAttribute('data-rh-default')) || count, order = [];
    if (!count) return;
    checks.forEach(function (c) { if (c.checked) order.push(c); });
    function price() {
      for (var i = 0; i < tiers.length; i++) if (Number(tiers[i].getAttribute('data-rh-tier')) === k) return tiers[i].getAttribute('data-price');
      return '';
    }
    function sync() {
      var all = k >= count, chosen = all ? checks : checks.filter(function (c) { return c.checked; });
      var ids = chosen.map(function (c) { return c.value; }), ns = chosen.map(function (c) { return c.getAttribute('data-n'); });
      if (pick) pick.hidden = all;
      if (pickN) pickN.textContent = k;
      f.querySelectorAll('[data-rh-item]').forEach(function (inp) {
        var on = ids.indexOf(inp.value) > -1, q = inp.nextElementSibling, pr = q && q.nextElementSibling;
        inp.disabled = !on; if (q) q.disabled = !on; if (pr) pr.disabled = !on;
      });
      var ready = chosen.length === k, ok = ready && (!consent || consent.checked), left = k - chosen.length;
      if (btn) {
        btn.textContent = !ready ? 'Elige ' + left + (left === 1 ? ' título más' : ' títulos más')
          : (all ? 'Llévate los ' : 'Llévate estos ') + k + ' por ' + price();
        btn.disabled = !ok; btn.classList.toggle('is-disabled', !ok); btn.setAttribute('aria-disabled', String(!ok));
      }
      tiers.forEach(function (t) { t.setAttribute('aria-checked', String(Number(t.getAttribute('data-rh-tier')) === k)); });
      [].forEach.call(fan, function (bk, i) { bk.classList.toggle('is-off', !all && ns.indexOf(String(i + 1)) < 0); });
    }
    function touched() { if (offer) offer.classList.add('is-picking'); }
    tiers.forEach(function (t) {
      t.addEventListener('click', function () {
        touched();
        k = Number(t.getAttribute('data-rh-tier'));
        if (k >= count) { checks.forEach(function (c) { c.checked = true; }); order = checks.slice(); }
        else {
          order = order.filter(function (c) { return c.checked; });
          while (order.length > k) order.pop().checked = false;
          checks.forEach(function (c) { if (order.length < k && !c.checked) { c.checked = true; order.push(c); } });
        }
        sync();
      });
    });
    checks.forEach(function (c) {
      c.addEventListener('change', function () {
        touched();
        if (c.checked) { order.push(c); while (order.length > k) order.shift().checked = false; }
        else order = order.filter(function (x) { return x !== c; });
        sync();
      });
    });
    if (consent) consent.addEventListener('change', sync);
    sync();
  });

  /* Oferta: el botón vacía el carrito, añade los títulos elegidos con su consentimiento y va al pago */
  document.querySelectorAll('form[data-rh-bundle]').forEach(function (f) {
    f.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      var box = f.querySelector('[data-rh-consent]');
      if (box && !box.checked) return;
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var prop = 'Solicitada por el cliente, que acepta perder el derecho de desistimiento al iniciarse la descarga';
      var items = [];
      f.querySelectorAll('[data-rh-item]:not([disabled])').forEach(function (i) { items.push({ id: Number(i.value), quantity: 1, properties: { 'Entrega inmediata': prop } }); });
      if (!items.length) return;
      var btn = f.querySelector('button[type="submit"]'); if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
      fetch(root + 'cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } })
        .then(function () { return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) }); })
        .then(function (r) { if (!r.ok) throw new Error('add'); window.location.href = root + 'checkout'; })
        .catch(function () { if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); } f.submit(); });
    });
  });

  /* Constelación dorada de la portada */
  var canvas = document.querySelector('[data-rh-constellation]');
  if (canvas && canvas.getContext) {
    var ctx = canvas.getContext('2d'), dpr = Math.min(window.devicePixelRatio || 1, 2), W, H, pts = [], mouse = { x: -9999, y: -9999 }, running = true;
    function size() {
      var r = canvas.getBoundingClientRect(); W = r.width; H = r.height;
      canvas.width = W * dpr; canvas.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var n = Math.round(Math.min(110, Math.max(40, W * H / 14000)));
      pts = [];
      for (var i = 0; i < n; i++) pts.push({ x: Math.random() * W, y: Math.random() * H, vx: (Math.random() - .5) * .22, vy: (Math.random() - .5) * .22, r: Math.random() * 1.4 + .4, p: Math.random() * 6.28 });
    }
    function frame() {
      if (!running) return;
      ctx.clearRect(0, 0, W, H);
      for (var i = 0; i < pts.length; i++) {
        var a = pts[i];
        a.x += a.vx; a.y += a.vy; a.p += .012;
        if (a.x < -20) a.x = W + 20; if (a.x > W + 20) a.x = -20; if (a.y < -20) a.y = H + 20; if (a.y > H + 20) a.y = -20;
        var dxm = a.x - mouse.x, dym = a.y - mouse.y, dm = dxm * dxm + dym * dym;
        if (dm < 22000) { a.x += dxm * .004; a.y += dym * .004; }
        for (var j = i + 1; j < pts.length; j++) {
          var b = pts[j], dx = a.x - b.x, dy = a.y - b.y, d = dx * dx + dy * dy;
          if (d < 15000) { ctx.strokeStyle = 'rgba(212,185,138,' + (0.16 * (1 - d / 15000)) + ')'; ctx.lineWidth = .6; ctx.beginPath(); ctx.moveTo(a.x, a.y); ctx.lineTo(b.x, b.y); ctx.stroke(); }
        }
        ctx.fillStyle = 'rgba(227,205,156,' + (0.35 + Math.sin(a.p) * 0.25) + ')';
        ctx.beginPath(); ctx.arc(a.x, a.y, a.r, 0, 6.2832); ctx.fill();
      }
      if (!reduce) requestAnimationFrame(frame);
    }
    size(); window.addEventListener('resize', size);
    canvas.parentElement.addEventListener('mousemove', function (e) { var r = canvas.getBoundingClientRect(); mouse.x = e.clientX - r.left; mouse.y = e.clientY - r.top; });
    canvas.parentElement.addEventListener('mouseleave', function () { mouse.x = mouse.y = -9999; });
    if (reduce) { frame(); }
    else {
      if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { var v = en[0].isIntersecting; if (v && !running) { running = true; requestAnimationFrame(frame); } else if (!v) running = false; }).observe(canvas);
      requestAnimationFrame(frame);
    }
  }
})();
